import { Grid, Link, List, ListItemText, Typography } from '@material-ui/core';
import React from 'react';
import Project from '../components/Project';

const Dominos = () => {
    const list = [
        `Co-developed the singleplayer gameplay;`,
        `Implemented the tiles positioning algorithm;`,
        `Built most of the UI Screens, Popup's and Animations;`,
    ];

    return (
        <Project>
            <Grid item xs={12}>
                <div className='aspect-ratio'>
                    <iframe
                        title='Dominos Trailer'
                        width='1904'
                        height='778'
                        src='https://www.youtube.com/embed/9j4fDGUV7wI'
                        frameBorder='0'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen
                    ></iframe>
                </div>
            </Grid>
            <Grid item xs={12}>
                <Typography variant='h1' component='h1' gutterBottom>
                    Dominos &amp; Dominos Battle
                </Typography>
                <Typography variant='overline' display='block'>
                    Synced Multiplayer Dominoes up to 4 Friends
                </Typography>
                <br />
                <Typography gutterBottom>
                    Our team rebuilt the game from scratch using Unity, as the
                    original had a 4 year old codebase using Starling Engine
                    (Flash).
                </Typography>
                <Typography>
                    We've also developed{' '}
                    <Link href='https://www.facebook.com/DomitoDominoesBot/'>
                        Dominos Battle
                    </Link>{' '}
                    for Facebook's Instant Games using JavaScript with{' '}
                    <Link href='https://www.pixijs.com/'>Pixi.js</Link>.
                </Typography>
                <br />
                <Typography>
                    <strong>Some of my tasks included:</strong>
                </Typography>
                <List>
                    {list.map((t, i) => (
                        <ListItemText key={`task-${i}`}>
                            &bull; {t}
                        </ListItemText>
                    ))}
                </List>
                <br />
                <Typography>
                    Developed at{' '}
                    <Link href='https://www.gazeus.com/en/'>Gazeus Games</Link>{' '}
                    and available on{' '}
                    <Link href='https://play.google.com/store/apps/details?id=air.com.jogatina.domino.android&hl=en&gl=US'>
                        Google Play
                    </Link>{' '}
                    and{' '}
                    <Link href='https://apps.apple.com/br/app/dominoes-jogatina-dominos/id922516896?l=en'>
                        Apple Store
                    </Link>
                    .
                </Typography>
            </Grid>
        </Project>
    );
};

export default Dominos;
